import { Component, OnInit } from '@angular/core';
import { ClientService } from 'src/app/services/client.service';

@Component({
  selector: 'app-rvc-dashboard-card',
  templateUrl: './rvc-dashboard-card.component.html',
  styleUrls: ['./rvc-dashboard-card.component.scss']
})
export class RvcDashboardCardComponent implements OnInit {

  count: number = 0;

  constructor(
    private clientService: ClientService
  ) { }

  ngOnInit(){
   this.countTotalClients();
  }
  
  countTotalClients() {
    this.clientService.countAll().subscribe(
      success => this.count = success,
      error => console.error(error)
    )
  }
}
